// $ BUILD_VERSION will be replaced with a unique string by webpack
const buildVersion: string = '$BUILD_VERSION';

// $ AE_VERSION $ and $ AE_VERSION_M $ will be replaced with correct values by webpack
const aeVersion: string = '$AE_VERSION$';

export {
  buildVersion,
  aeVersion
};

export default buildVersion;
